var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJiraLogo = function SvgJiraLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M30.664 0h-15.41a6.956 6.956 0 0 0 6.956 6.956h2.839v2.74A6.956 6.956 0 0 0 32 16.65V1.337C32 .599 31.402 0 30.663 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jiraLogo_svg__a)",
    d: "M23.038 7.678H7.628a6.956 6.956 0 0 0 6.953 6.952h2.838v2.75a6.956 6.956 0 0 0 6.956 6.946V9.015c0-.738-.598-1.337-1.337-1.337"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jiraLogo_svg__b)",
    d: "M15.41 15.352H0a6.956 6.956 0 0 0 6.956 6.956h2.848v2.74A6.956 6.956 0 0 0 16.747 32V16.689c0-.739-.6-1.337-1.337-1.337"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jiraLogo_svg__a",
    x1: 4199.18,
    x2: 2536.81,
    y1: 15.343,
    y2: 1958.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jiraLogo_svg__b",
    x1: 4304.21,
    x2: 2381.27,
    y1: 37.013,
    y2: 2155.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
};
export default SvgJiraLogo;